import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikDaekningKundeBrugt } from '../../models/StatistikDaekningKundeBrugt';

@Component({
    selector: 'app-statistik-daekning-sags-ui',
    templateUrl: './statistik-daekning-sag-modal.html',
    styleUrls: ['./statistik-daekning-sag-modal.scss'],
    standalone: false
})
export class StatistikDaekningSagModal {
    @Input() brugtTimer: StatistikDaekningKundeBrugt[];
    @Input() brugtKr: StatistikDaekningKundeBrugt[];

    constructor(
        private activeModal: NgbActiveModal
    ) { }

    onDismiss() {
        this.activeModal.dismiss();
    }

    hoursTotal() {
        let total = 0;
        this.brugtTimer.forEach(element => {
            total += element.timer;
        });
        return Math.round(total);
    }

    amountTotal(data: StatistikDaekningKundeBrugt[]) {
        let total = 0;
        data.forEach(element => {
            total += element.beloeb;
        });
        return Math.round(total);
    }
}
